import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AppState, Actions, store, PanelState, IPageState, DisplayWindow } from '../appredux'

import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import { Paper, WithStyles, SvgIconTypeMap, CardMedia } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import './Paper.css'
import './PanelRightBasket.css'
import './LeftPanel.css';
import { fontSelect } from '../fonts'

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Backdrop from '@material-ui/core/Backdrop';
import MenuIcon from '@material-ui/icons/Menu';

import LocalDiningIcon from '@material-ui/icons/LocalDining';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import HistoryIcon from '@material-ui/icons/History';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import HomeIcon from '@material-ui/icons/Home'
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import ResponsiveImgMaterialUi from 'responsive-img-material-ui';
import CONFIG from '../cfg/config';

//PM 2021-06-25
interface MenuProps {
  page: IPageState,
}

interface MenuState {
    anchorEl: any,
  }
  

class PanelLeftTest extends React.Component<MenuProps & WithStyles<typeof styles>, MenuState>  {
  logoUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/logo.png`

  constructor(props: MenuProps & WithStyles<typeof styles>) {
    super(props, {});

    this.state = {
        anchorEl: null,
      };
  }

  openMenu = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ anchorEl: null });
  };

  //PM 2021-06-25
  render = () => {
    const { classes } = this.props;

    const openMenu = Boolean(this.state.anchorEl);

    const menuItems = [
      {
        key: "1",
        className: `${classes.menuItem} ${classes.divider}`,
        onClick: () => { store.dispatch(Actions.pageState.setDisplayMenu(1)); this.closeMenu() },
        classNameIcon: classes.green,
        opis: "     zamówienie",
        Icon: LocalDiningIcon as OverridableComponent<SvgIconTypeMap<{}, "svg">>,
      },
      {
        key: "3",
        className: `${classes.menuItem}`,
        onClick: () => { store.dispatch(Actions.pageState.setDisplayWindow(DisplayWindow.History)); this.closeMenu() },
        classNameIcon: classes.blueDark,
        opis: "     historia",
        Icon: HistoryIcon,
      },
      {
        key: "2",
        className: `${classes.menuItem} ${classes.divider}`,
        onClick: () => { store.dispatch(Actions.pageState.setDisplayMenu(2)); this.closeMenu() },
        classNameIcon: classes.blueDark,
        opis: "     płatność",
        Icon: PaidOutlinedIcon as OverridableComponent<SvgIconTypeMap<{}, "svg">>,
      },
      {
        key: "4",
        className: classes.menuItem,
        onClick: () => { store.dispatch(Actions.pageState.setDisplayMenu(3)); this.closeMenu() },
        classNameIcon: classes.brownLight,
        opis: "     info",
        Icon: HelpOutlineIcon,
      },
      {
        key: "4",
        className: classes.menuItem,
        onClick: () => { store.dispatch(Actions.pageState.setDisplayMenu(4)); this.closeMenu() },
        classNameIcon: classes.brownLight,
        opis: "     kontakt",
        Icon: HomeIcon,
      },
    ];

    return (
      <>
            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={this.openMenu}
                style={{position: "absolute"}}
            >
                <MenuIcon />
            </IconButton>
            <Backdrop className={classes.backdrop} open={openMenu}>
                <Menu
                    id="long-menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    elevation={15}
                    open={openMenu}
                    onClose={this.closeMenu}
                    PaperProps={{
                        style: {
                            //maxHeight: 10 * 4.5,
                            width: '30ch',
                            left: "200px",
                            top: "200px"
                            //paddingTop: "0"
                        },
                    }}

                    MenuListProps={{
                        style: {
                            //maxHeight: 10 * 4.5,
                            //width: '30ch',
                            color: "#555",
                            width: "100%",
                            paddingRight: "0"
                            //paddingTop: "0",
                            //paddingBottom: "0"
                        },
                    }}
                >

                    {/*<hr/>*/}
                    {/* <Typography 
                                gutterBottom component="h6" style={{padding: "8px 16px"}}
                                color='textSecondary'
                              >
                                <b>{"Dane"}</b>
                              </Typography> */}
                    
                    {menuItems.map(menuItem => (
                        <MenuItem key={menuItem.key} className={menuItem.className} onClick={menuItem.onClick}>
                            <menuItem.Icon className={menuItem.classNameIcon} style={{width: "24px", height: "24px"}}/>
                            <Typography className={classes.menuText}
                                color='textSecondary'
                                variant='caption'
                            >
                                {menuItem.opis}
                            </Typography>
                        </MenuItem>
                    ))}
            {/* <ResponsiveImgMaterialUi style={{ width: "100%", maxWidth: "calc(100%  + -20px)", maxHeight: "220px", padding: "10px 10px 0px" }}
              xs={this.logoUrl}
              md={this.logoUrl}
              lg={this.logoUrl}
            /> */}
            <CardMedia
                    style={{ width: "100%", maxWidth: "calc(100%  + -20px)", maxHeight: "220px", padding: "10px 10px 0px" }}
                    image={this.logoUrl}
                  //title="logo"
                  component="img"
                  onError={(event: any) => event.target.style.display = 'none'}
                  />
                   
                   

                </Menu>
            </Backdrop>
      </>
    )
  }
}

//do wywalenia
const styles = (theme: Theme) => {
  return ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },
      divider: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        backgroundClip: 'padding-box',
      },
      menuItem: {
        whiteSpace: "pre" as "pre",
        paddingBottom: "8px",
        paddingTop: "8px",
        minHeight: "44px",
      },
      menuText: {
        fontSize: "0.85rem"
      },
      green: {
        //color: 'rgba(69, 139, 0, 0.5)'
        color: 'rgba(40, 160, 0, 0.8)'
      },
      blueDark: {
        //color: 'rgba(0, 90, 126, 0.5)'
        color: 'rgba(0, 90, 126, 0.8)'
      },
      brownLight: {
        //color: 'rgba(191, 136, 85, 0.5)'
        color: 'rgba(191, 136, 85, 0.8)'
      },
   
  });
}

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

//export default PanelLeftTest;
export default connect(mapStateToProps)(withStyles(styles)(PanelLeftTest));









